module.exports = __webpack_public_path__ + "static/media/vintage07.5f25092d.png";